import { render, staticRenderFns } from "./DocFaceLibraryResourceNew.vue?vue&type=template&id=33e43206&scoped=true"
import script from "./DocFaceLibraryResourceNew.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryResourceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e43206",
  null
  
)

export default component.exports